import uniq from 'lodash-es/uniq';
import { IState } from '..';
import { getDefaultSalesDistricts } from '../auth';
import { getRegionSalesDistricts } from '../lookups/lookupsSelectors';
import { IBaseFilters } from './filtersInterfaces';
import { IFiltersState } from './filtersReducer';

export function getFilters<T>(state: IState, type: keyof IFiltersState): T {
  return state.filters[type] as any;
}

export function getFilteredSalesDistricts(state: IState, filters: IBaseFilters): string[] {
  let sds: string[] = getDefaultSalesDistricts(state);

  if (filters.salesDistricts.length > 0 || filters.regions.length > 0) {
    const regionSds = getRegionSalesDistricts(state, filters.regions);
    sds = uniq([...filters.salesDistricts, ...regionSds]);
  }

  return sds;
}

export function isFiltered(state: IState, type: keyof IFiltersState): boolean {
  const filters = state.filters[type];
  let filtered = false;

  Object.entries(filters).forEach(([k, f]) => {
    // if the key is sortBy, don't check it
    if (k !== 'sortBy') {
      // if it is an array, check length
      if (Array.isArray(f)) {
        filtered = filtered || f.length > 0;
      }

      if (typeof f === 'string' && f) {
        filtered = true;
      }
    }
  });

  return filtered;
}
